import React, { useContext } from 'react';
import { Typography } from '@chegg-ui/typography';
import { FooterContext } from '../shared';
import { PrimaryNavContainer, PrimaryNavContent, PrimaryNavLink } from '../styles/primaryNav';

var PrimaryNav = function PrimaryNav(_ref) {
  var navLinks = _ref.navLinks,
      children = _ref.children;

  var _useContext = useContext(FooterContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(PrimaryNavContainer, {
    "data-test": "".concat(dataTestPrefix, "-primary-nav-container")
  }, /*#__PURE__*/React.createElement(PrimaryNavContent, null, navLinks.map(function (_ref2, index) {
    var href = _ref2.href,
        text = _ref2.text,
        onClick = _ref2.onClick,
        useAbsolute = _ref2.useAbsolute,
        target = _ref2.target;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrimaryNavLink, {
      key: index,
      href: useAbsolute ? href : "".concat(envUrl).concat(href),
      target: target,
      "data-test": "".concat(dataTestPrefix, "-primary-nav-link-").concat(index),
      onClick: onClick
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "button",
      variantType: "sm"
    }, text)), index < navLinks.length - 1 && /*#__PURE__*/React.createElement("span", null, " / "));
  })), children);
};

PrimaryNav.displayName = 'PrimaryNav';
export default PrimaryNav;